import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const input = "w-full bg-surface border border-gold/20 rounded-xl px-4 py-2.5 text-cream placeholder:text-faded focus:outline-none focus:ring-1 focus:ring-gold text-sm";

export default function AdminMembers() {
    const [members, setMembers] = useState([]);
    const [sel, setSel] = useState(null);
    const [adjust, setAdjust] = useState({ points: 0, reason: "" });

    const load = () => api.get("/admin/members").then((r) => setMembers(r.data));
    useEffect(() => { load(); }, []);

    const submit = async (e) => {
        e.preventDefault();
        await api.post("/admin/loyalty/adjust", { user_id: sel.id, points: parseInt(adjust.points), reason: adjust.reason || "Manual adjustment" });
        toast.success("Points adjusted"); setSel(null); setAdjust({ points: 0, reason: "" }); load();
    };

    return (
        <div>
            <h1 className="font-serif text-4xl text-cream mb-6">Members &amp; Loyalty</h1>
            <div className="rounded-2xl border border-gold/10 overflow-hidden" data-testid="members-table">
                <table className="w-full text-sm">
                    <thead className="bg-surface2 text-faded text-left"><tr><th className="p-4">Name</th><th className="p-4">Email</th><th className="p-4">Role</th><th className="p-4">Membership</th><th className="p-4">Points</th><th className="p-4"></th></tr></thead>
                    <tbody>
                        {members.map((m) => (
                            <tr key={m.id} className="border-t border-gold/10">
                                <td className="p-4 text-cream">{m.name}</td>
                                <td className="p-4 text-ash">{m.email}</td>
                                <td className="p-4 text-ash capitalize">{m.role}</td>
                                <td className="p-4 text-ash">{m.membership_status === "active" ? m.membership_tier : "-"}</td>
                                <td className="p-4 text-gold">{m.points}</td>
                                <td className="p-4 text-right"><button onClick={() => setSel(m)} className="text-gold text-xs border border-gold/30 rounded-full px-3 py-1 hover:bg-gold/10">Adjust</button></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <Dialog open={!!sel} onOpenChange={(o) => !o && setSel(null)}>
                <DialogContent className="bg-surface2 border-gold/20 text-cream max-w-sm">
                    <DialogHeader><DialogTitle className="font-serif text-2xl">Adjust points · {sel?.name}</DialogTitle></DialogHeader>
                    <form onSubmit={submit} className="space-y-3">
                        <p className="text-sm text-ash">Current: <span className="text-gold">{sel?.points} pts</span>. Use a negative number to deduct.</p>
                        <input type="number" placeholder="Points (+/-)" value={adjust.points} onChange={(e) => setAdjust({ ...adjust, points: e.target.value })} className={input} />
                        <input placeholder="Reason" value={adjust.reason} onChange={(e) => setAdjust({ ...adjust, reason: e.target.value })} className={input} />
                        <button className="w-full bg-gold text-ink rounded-full py-2.5 font-medium">Apply</button>
                    </form>
                </DialogContent>
            </Dialog>
        </div>
    );
}
